





































































































import Vue from 'vue';
import { evaultCategoryKey } from '@/constants';
import {
  OpenUpdateDocumentDetailScreen,
  OpenRemoveDocumentScreen,
  OpenViewAttachmentScreen,
  OpenMatchToTransactionScreen,
} from '@/mixins/get-content-mixins';
import { ExtendMixins } from '@/services';

export default ExtendMixins(
  OpenUpdateDocumentDetailScreen,
  OpenRemoveDocumentScreen,
  OpenViewAttachmentScreen,
  OpenMatchToTransactionScreen,
).extend({
  name: 'DocumentCard',
  props: {
    document: {
      type: Object as () => any,
      required: true,
    },
    image: {
      type: Object as () => any,
      default() {
        return null;
      },
    },
  },
  computed: {
    name(): string {
      return this.document.fileNickname
        ? this.document.fileNickname
        : this.document.fileName;
    },
    category(): string {
      return this.$options.filters.t(evaultCategoryKey[this.document.category]);
    },
    isPDF(): string {
      return this.document.fileName && this.document.fileName.endsWith('.pdf');
    },
    isTIFF(): string {
      const filename = this.document.fileName;
      return (
        filename && (filename.endsWith('.tiff') || filename.endsWith('.tif'))
      );
    },
    isSubmitted(): boolean {
      return this.document.isSubmitted;
    },
    showGetReimbursedAction(): boolean {
      return this.document.category !== 6 && this.document.category !== 8;
    },
    showPayProviderAction(): boolean {
      return this.document.category !== 6 && this.document.category !== 8;
    },
    showMatchToTransactionAction(): boolean {
      return this.document.category !== 8;
    },
  },
  methods: {
    optionsButtonClick(eventText): void {
      window.dataLayer.push({
        event: 'imageOptions',
        'gtm.elementTarget': eventText,
      });
    },
    goToDocument(attachment): void {
      // Trigger Analytics
      window.dataLayer.push({
        event: 'seeDetails',
      });

      this.openViewAttachmentScreen({ attachment });
    },
  },
});
